import { CritereRechercheValue } from './critere-recherche-value';

export class CritereRecherche {

    crr_id: string;
    crr_ref: string;
    crr_libelle: string;
    crr_type: string;
    crr_type_input: string;
    crr_operator: string;
    crr_tolerance: string;
    crr_special_list: string;
    crr_target_table: string;
    crr_target_column: string;
    crr_etat: string;
    crr_favoris: string;
    crr_order: string;
    crr_readonly: string;
    crr_required: boolean;
    crr_strict: boolean;
    list_values: CritereRechercheValue[];
    selected_values: string[];
    computed_selected_values: string[];

    constructor(data?: any) {
        if (!data) {
            data = [];
        }

        this.crr_id             = data['crr_id'] ? data['crr_id'] : null;
        this.crr_ref            = data['crr_ref'] ? data['crr_ref'] : null;
        this.crr_libelle        = data['crr_libelle'] ? data['crr_libelle'] : null;
        this.crr_type           = data['crr_type'] ? data['crr_type'] : 'input';
        this.crr_type_input     = data['crr_type_input'] ? data['crr_type_input'] : 'text';
        this.crr_operator       = data['crr_operator'] ? data['crr_operator'] : 'equal';
        this.crr_tolerance      = data['crr_tolerance'] ? data['crr_tolerance'] : 0;
        this.crr_special_list   = data['crr_special_list'] ? data['crr_special_list'] : '';
        this.crr_target_table   = data['crr_target_table'] ? data['crr_target_table'] : null;
        this.crr_target_column  = data['crr_target_column'] ? data['crr_target_column'] : null;
        this.crr_etat           = data['crr_etat'] ? data['crr_etat'] : 1;
        this.crr_favoris        = data['crr_favoris'] ? data['crr_favoris'] : 0;
        this.crr_order          = data['crr_order'] ? data['crr_order'] : null;
        this.crr_required       = data['crr_required'] ? (data['crr_required'] === '1' ? true : false) : false;
        this.crr_strict         = data['crr_strict'] ? (data['crr_strict'] === '1' ? true : false) : false;
        this.crr_readonly       = data['crr_readonly'] ? data['crr_readonly'] : null;

        this.selected_values            = data['selected_values'] ? data['selected_values'] : [''];
        this.computed_selected_values   = data['computed_selected_values'] ? data['computed_selected_values'] : [''];
        this.list_values = [];
        if (data['list_values'] && data['list_values'].length > 0) {
            data['list_values'].forEach(element => {
                this.list_values.push(new CritereRechercheValue(element));
            });
        }

        /*if (this.crr_type === 'min_max' && this.selected_values[0] === '') {
            this.selected_values[0] = '0';
        }*/
    }

}
